import { DatePipe } from '@angular/common';
import { OnDestroy } from '@angular/core';
import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation, ElementRef, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { LoginService } from '../../../common/services/Login.service';
import scrollIntoView from 'scroll-into-view-if-needed'
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { constObj } from '../../../common/Constants/constants';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'pub-dita-content',
  templateUrl: './dita-content.component.html',
  styleUrls: ['./dita-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DitaContentComponent implements OnInit, AfterViewInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  @Input() dita: any;
  @Input() id: string = '';
  @Input() paraNum: string = '';
  @Input() annotationCount: string = '';
  @Input() bookmarkCount: string = '';
  @Input() printqueueAdd: boolean = false;
  @Input() archivePage: boolean = false;
  @Input() actionLabel: string[] = [];
  @Input() rightOverLayPage: boolean = false;
  @Input() crossReferencedContentID: string;
  @Input() crossreferencestandardType: string;
  @Input() crossreferencestandardNumber: string;
  @Input() crossreferenceparagraphNumber: string;
  @Input() ParentComponent: string = '';
  @Input() BreadcrumbPath: string = '';
  @Input() crumbData: any = [];
  @Input() compname: string = "";
  @Input() paraTitle: any[] = [];
  @Input() UserInfo: any;
  @Input() pageNums: string = "";
  @Input() s3ImageBasePath: string = "";
  @Input() PendingContentMerge: any;
  @Input() pageurl;
  @Input() pageTitle: string = "";
  @Input() topic_subtopicNum: string = "";
  @Input() preloadContentPage: string[] = [];
  @Output() eventemit = new EventEmitter<string>();
  pendingContentDataList: any
  lineRequired: boolean = true;
  annotationContentBool: boolean = false;
  annotationPrintContentBool: boolean = false;
  paraArticleId: string = "";
  constructor(
    private elementRef: ElementRef,
    public commonDataService: CommonDataService,
    private graphQLService: GraphqlService,
    public loginService: LoginService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private datePipe: DatePipe, public dialog: MatDialog) { }

  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase()?.includes("xref") && !event.target.className?.includes("term")) {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (!ahref.toLocaleLowerCase().includes("notice to constituents")) {
        if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (isNaN(Number(ahref.split("-")[0])) && !ahref.toLocaleLowerCase().includes("notice to constituents") && !ahref.toLocaleLowerCase().includes("maintenance update") && !ahref.toLocaleLowerCase().includes("accounting standards update") && !ahref.toLocaleLowerCase().includes("paragraph not used") && !ahref.toLocaleLowerCase().includes("subsection")) {
        return false;
      }
      //else if (ahref.toLocaleLowerCase().includes("maintenance update") || ahref.toLocaleLowerCase().includes("accounting standards update") || ahref.toLocaleLowerCase().includes(("section")) || ahref.toLocaleLowerCase().includes("subsection")) {
      //  let otherSourceUrlParts = event.target.getAttribute('href').split("/");
      //  event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlParts[otherSourceUrlParts.length - 1]);
      //}
      else if (ahref.toLocaleLowerCase().includes("notice to constituents") || ahref.toLocaleLowerCase().includes("paragraph not used")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/noticeToConstituents");
      }
      else if (ahref.includes("-") && ahref.split("-").length >= 2) {
        let navPath = event.target.innerText?.split("-");
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
    }
    else if (event.target.className.includes("term")) {
      event.srcElement.parentElement.removeAttribute("href");
      event.srcElement.parentElement.className = event.srcElement.parentElement.className.includes("cursor-pointer") ? event.srcElement.parentElement.className : event.srcElement.parentElement.className + " cursor-pointer";
    }
  }

  navPathTreeCall$: Subscription;
  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          if (navPath[0].includes("Section ")) {
            navPath[0] = navPath[0].replace("Section ", "");
          }
          let navPathUrl: string = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          event.srcElement.setAttribute("href", "/" + navPathUrl.split("/")[0] + "/" + navPathUrl.split("/")[1] + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          this.navPathTreeCall$ = this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
        }
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  getsnum(val) {
    const ariaSname = val.getAttribute('aria-sname');
    const ariaSnumber = val.getAttribute('aria-snumber');
      const dataObject = {
        ariaSname,
        ariaSnumber
      };       
    return (dataObject);
  }

  
  ngOnInit(): void {
    this.dita = this.sanitizer.bypassSecurityTrustHtml(this.dita);
    this.paraArticleId = (this.pageTitle == "" ? "para" : this.pageTitle) + this.id.replace(/ /g, "_");
    //this.crossReferencedContentID = this.crossReferencedContentID != "" && this.crossReferencedContentID != undefined ? this.topic_subtopicNum + this.crossReferencedContentID : this.crossReferencedContentID;
    if (this.crossReferencedContentID != "" && this.crossReferencedContentID != undefined) {
      this.crossReferencedContentID = this.topic_subtopicNum + this.crossReferencedContentID;
      sessionStorage.setItem("paragraphNum", this.crossReferencedContentID);
    }
    
  
    if (this.paraNum?.toLowerCase() === this.crossReferencedContentID?.toLowerCase() && this.crossreferencestandardType && this.crossreferencestandardNumber) {
      //add highlight class to this paragraph
      
      let ditaHTML = new DOMParser().parseFromString(this.dita['changingThisBreaksApplicationSecurity'], 'text/html');

      let itemsHiddenFragment = ditaHTML.getElementsByClassName('hide-content sfragment-data');
      for (let i = 0; i < itemsHiddenFragment.length; i++) {
        // let hasStdType = itemsHiddenFragment[i].innerHTML.toLowerCase().includes(this.crossreferencestandardType.toLowerCase());
        // let hasStdNum = itemsHiddenFragment[i].innerHTML.toLowerCase().includes(this.crossreferencestandardNumber.toLowerCase());
        // let hasParaNum = itemsHiddenFragment[i].innerHTML.toLowerCase().includes(this.crossreferenceparagraphNumber.toLowerCase());

        let hasStdType = itemsHiddenFragment[i].getElementsByClassName("sfragment-standard-name")[0].innerHTML.toLowerCase() == this.crossreferencestandardType.toLowerCase() ? true : false;
        let hasStdNum = itemsHiddenFragment[i].getElementsByClassName("sfragment-standard-number")[0].innerHTML.toLowerCase() == this.crossreferencestandardNumber.toLowerCase() ? true : false;
        let hasParaNum = itemsHiddenFragment[i].getElementsByClassName("sfragment-para-number")[0].innerHTML.toLowerCase() == this.crossreferenceparagraphNumber.toLowerCase() ? true : false;

        if (hasStdNum && hasStdType && hasParaNum) {
          itemsHiddenFragment[i].parentElement.classList.add('cross-referenced-para-content-highlight');
        }
      }
      this.dita = this.sanitizer.bypassSecurityTrustHtml(ditaHTML.body.innerHTML);
      
    }
    else if (this.paraNum?.toLowerCase() === this.crossReferencedContentID?.toLowerCase() && this.crossReferencedContentID !== "" && this.paraNum !== "") {
      let ditaHTML = new DOMParser().parseFromString(this.dita['changingThisBreaksApplicationSecurity'], 'text/html');
      let normText = ditaHTML.body.getElementsByClassName("norm-text");
      for (let i = 0; i < normText.length; i++) {
        normText[i].classList.add('cross-referenced-para-content-highlight');
      }
      this.dita = this.sanitizer.bypassSecurityTrustHtml(ditaHTML.body.innerHTML);
    }

    this.commonDataService.annotationWithinContent.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == this.id) {
        this.annotationContentBool = true;
      }
    });
    this.commonDataService.displayallannotation.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.annotationPrintContentBool = false;
      if (data == "displayallannotations") {
        this.annotationPrintContentBool = false;
        this.annotationContentBool = true;
      }
      else if (data == "displayallannotationswithprint") {
        this.commonDataService.showLoader.next(true);
        this.annotationPrintContentBool = true;
      }
      else if (data == "hidePrintallannotations") {
        this.annotationPrintContentBool = false;
      }
      else {
        this.annotationContentBool = false;
      }
    });

    this.commonDataService.printTrigger.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == true) {
        this.commonDataService.printTrigger.next(false);
        this.addPendingContentForPrint();
      }
    });

    this.annotationContentBool = false;
  
  }

  ngOnDestroy() {
    if (this.navPathTreeCall$ != undefined && this.navPathTreeCall$ != null) {
      this.navPathTreeCall$.unsubscribe();
    }
    this.eventemit.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  s3Path;
  addImage() {
    let article = document.getElementById(this.paraArticleId);
    if (article != null) {
      let ImageDivs = article.getElementsByClassName("img") as HTMLCollectionOf<HTMLImageElement>;
      if (ImageDivs.length > 0) {
        for (let i = 0; i < ImageDivs.length; i++) {
          let hasStyle = ImageDivs[i].getAttribute("style");
          if (hasStyle == null) {
            ImageDivs[i].onload = function () {
              ImageDivs[i].style.width = String(ImageDivs[i].naturalWidth) + "px";
              ImageDivs[i].style.height = String(ImageDivs[i].naturalHeight) + "px";
              ImageDivs[i].style.maxHeight = '100%';
              ImageDivs[i].style.maxWidth = '100%';
              ImageDivs[i].style.boxSizing = 'border-box';
            }
          }
        }
      }
    }
  }

  addPendingContentForPrint() {
    let article = document.getElementById(this.paraArticleId+"print");
    if (article != null) {
      let ImageDivs = article.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
      if (ImageDivs.length == 1) {

        let transitionGuidanceNum = ImageDivs[0].getElementsByClassName("xref")[0]?.innerHTML
        if (this.PendingContentMerge?.length > 0) {

          this.PendingContentMerge.forEach(merge => {
            if (merge.para != null) {
              var paraswappedList = merge?.para?.split("-");
              //console.log(merge?.para.split("-")[1] + "-" + merge?.para.split("-")[0] + "-" + merge?.para.split("-")[2] + "-" + merge?.para.split("-")[3]);
              var paraswapped = paraswappedList.length == 4 ? paraswappedList[1] + "-" + paraswappedList[0] + "-" + paraswappedList[2] + "-" + paraswappedList[3] : ""
            }
            if ((merge.para == this.paraNum || paraswapped == this.paraNum) && merge.transitionGuidance == transitionGuidanceNum) {
              if (merge.outofSystemScope == "yes") {
                this.highlightParaSolid(article);
              }
              else {
                this.highlightParadotted(article);
                if (merge.yesOrNo == "1") {
                  this.addIntegratedText(article)
                  this.removeNormData(article);

                }
                else if (merge.yesOrNo == "2") {
                  this.removePendingData(article)
                }
              }
            }
            else if ((merge.para == this.paraNum || paraswapped == this.paraNum) && merge.transitionGuidance != transitionGuidanceNum && ImageDivs.length > 1) {
              ImageDivs[0].remove();
            }

          })
        }

      }
      if (ImageDivs.length > 1 && this.PendingContentMerge?.length > 0) {
        this.pendingContentDataList = [];
        for (let i = 0; i < ImageDivs.length; i++) {
          let date = article.getElementsByClassName("p-alphabet") as HTMLCollectionOf<HTMLElement>;
          let dateRange = date[i].innerHTML;
          let startRange = dateRange.substring(
            dateRange.indexOf(")") + 1,
            dateRange.lastIndexOf(";")
          );
          let endRange = dateRange.split("(N)")[1]
          let start = this.datePipe.transform(startRange, 'MM/dd/yyyy');
          let end = this.datePipe.transform(endRange, 'MM/dd/yyyy');
          let transitionGuidanceParaNum = ImageDivs[i].getElementsByClassName("xref")[0]?.innerHTML


          if (this.PendingContentMerge?.length > 0) {
            let mergeList = this.PendingContentMerge.filter(y => y.transitionGuidance == transitionGuidanceParaNum && (y.para == this.paraNum || (y?.para?.split("-").length == 4 ? (y.para.split("-")[1] + "-" + y?.para.split("-")[0] + "-" + y?.para.split("-")[2] + "-" + y?.para.split("-")[3]) == this.paraNum : "")))[0]
            if (mergeList != undefined) {
              this.pendingContentDataList.push({ startDate: start, endDate: end, yesOrNo: mergeList.yesOrNo, profileType: mergeList.typeofProfile, transitionGuidanceParaNum: transitionGuidanceParaNum, outofSystemScope: mergeList.outofSystemScope });
            }
          }
        }
        if (this.pendingContentDataList.length > 0) { this.handlePendingcontent(this.pendingContentDataList); }
      }
    }
      

  }

  addPendingContent() {
    let article = document.getElementById(this.paraArticleId);
    if (article != null) {
      let ImageDivs = article.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
      if (ImageDivs.length == 1) {

        let transitionGuidanceNum = ImageDivs[0].getElementsByClassName("xref")[0]?.innerHTML
        if (this.PendingContentMerge?.length > 0) {

          this.PendingContentMerge.forEach(merge => {
            if (merge.para != null) {
              var paraswappedList = merge?.para?.split("-");
              var paraswapped = paraswappedList.length == 4 ? paraswappedList[1] + "-" + paraswappedList[0] + "-" + paraswappedList[2] + "-" + paraswappedList[3] : ""
            }
            if ((merge.para == this.paraNum || paraswapped == this.paraNum) && merge.transitionGuidance == transitionGuidanceNum) {
              if (merge.outofSystemScope == "yes") {
                this.highlightParaSolid(article);
              }
              else {
                this.highlightParadotted(article);
                if (merge.yesOrNo == "1") {
                  this.addIntegratedText(article)
                  this.removeNormData(article);

                }
                else if (merge.yesOrNo == "2") {
                  this.removePendingData(article)
                }
              }
            }
            else if ((merge.para == this.paraNum || paraswapped == this.paraNum) && merge.transitionGuidance != transitionGuidanceNum && ImageDivs.length > 1) {
              ImageDivs[0].remove();
            }

          })
        }

      }
      if (ImageDivs.length > 1 && this.PendingContentMerge?.length > 0) {
        this.pendingContentDataList = [];
        for (let i = 0; i < ImageDivs.length; i++) {
          let date = article.getElementsByClassName("p-alphabet") as HTMLCollectionOf<HTMLElement>;
          let dateRange = date[i].innerHTML;
          let startRange = dateRange.substring(
            dateRange.indexOf(")") + 1,
            dateRange.lastIndexOf(";")
          );
          let endRange = dateRange.split("(N)")[1]
          let start = this.datePipe.transform(startRange, 'MM/dd/yyyy');
          let end = this.datePipe.transform(endRange, 'MM/dd/yyyy');
          let transitionGuidanceParaNum = ImageDivs[i].getElementsByClassName("xref")[0]?.innerHTML


          if (this.PendingContentMerge?.length > 0) {
            let mergeList = this.PendingContentMerge.filter(y => y.transitionGuidance == transitionGuidanceParaNum && (y.para == this.paraNum || (y?.para?.split("-").length == 4 ? (y.para.split("-")[1] + "-" + y?.para.split("-")[0] + "-" + y?.para.split("-")[2] + "-" + y?.para.split("-")[3]) == this.paraNum : "")))[0]
            if (mergeList != undefined) {
              this.pendingContentDataList.push({ startDate: start, endDate: end, yesOrNo: mergeList.yesOrNo, profileType: mergeList.typeofProfile, transitionGuidanceParaNum: transitionGuidanceParaNum, outofSystemScope: mergeList.outofSystemScope });
            }
          }
        }
        if (this.pendingContentDataList.length > 0) { this.handlePendingcontent(this.pendingContentDataList); }

      }


      if (ImageDivs.length > 0) {
        for (let i = 0; i < ImageDivs.length; i++) {
          if (!ImageDivs[i].className.includes("formatted")) {
            let normText = article.getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;
            if (i == 0 && normText.length == 0) {
              ImageDivs[i].className += " mt-0";
            }
            ImageDivs[i].className += " formatted"
            let divBlock = document.createElement("div");
            let img = document.createElement("img");
            img.src = "../../../../assets/icons/clock-black.svg";
            img.alt = "Clock Image";
            img.className = "pending-clock-icon"
            let imgQuestion = document.createElement("img");
            imgQuestion.src = "../../../../assets/icons/Help.svg";
            imgQuestion.alt = "Question Image";
            imgQuestion.className = "pending-question-icon cursor-pointer";
            imgQuestion.id = "/helppendingcontent";
            let textBlock = document.createElement("span");
            textBlock.innerText = "PENDING CONTENT";
            textBlock.className = "mat-Info";
            divBlock.appendChild(img);
            divBlock.appendChild(textBlock);
            divBlock.appendChild(imgQuestion);
            divBlock.className = "bottomMargin";
            ImageDivs[i].insertBefore(divBlock, ImageDivs[i].firstChild);
            let dateSection = article.getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

            if (dateSection.length > 0) {
              for (let j = 0; j < dateSection.length; j++) {
                let divBlock1 = document.createElement("div");
                divBlock1.className = "mt-1rem";
                dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
                dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
                dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

                let guidanceLink = dateSection[j].nextElementSibling;
                if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
                  guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
                }
              }
            }
          }
        }
      }
    }
  }
  addSpacebeforeSfragment(article) {
    let dateSection = article.getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

    if (dateSection.length > 0) {
      for (let j = 0; j < dateSection.length; j++) {
        let guidanceLink = dateSection[j].nextElementSibling;
        if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
          guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
        }
      }
    }
  }
  handlePendingcontent(pendingContentDataList) {
    let article = document.getElementById(this.paraArticleId);
    let ImageDivs = article.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
    let yesFilter = pendingContentDataList.filter(x => x.yesOrNo == "1")
    let noFilter = pendingContentDataList.filter(x => x.yesOrNo == "2")
    if (yesFilter.length > 0) {
      if (yesFilter.filter(x => x.outofSystemScope == "yes").length > 0) {
        this.highlightParaSolid(article);
      }
      else {
        let transitionGuidanceParaNumList = [];
        for (let i = 0; i < ImageDivs.length; i++) {
          transitionGuidanceParaNumList.push({ index: i, transitionguidance: ImageDivs[i].getElementsByClassName("xref")[0].innerHTML, integrate: false })
        }
        transitionGuidanceParaNumList.forEach(x => {
          x.integrate = yesFilter.some(y => y.transitionGuidanceParaNum == x.transitionguidance);
        });
        let lastIndex = transitionGuidanceParaNumList.map(e => e.integrate).lastIndexOf(true);
        let isArrayContigous = true;
        for (let i = lastIndex; i >= 0; i--) {
          if (transitionGuidanceParaNumList[i].integrate == false) {
            isArrayContigous = false
            this.highlightParaSolid(article);
            break;
          }

        }
        if (isArrayContigous) {
          let transitionGuidancePara = ImageDivs[lastIndex].getElementsByClassName("xref")[0].innerHTML
          for (let i = 0; i < ImageDivs.length; i++) {
            let transitionGuidanceParaNum = ImageDivs[i].getElementsByClassName("xref")[0].innerHTML
            if (transitionGuidanceParaNum != transitionGuidancePara) {
              if (ImageDivs != undefined && ImageDivs.length > 0) {
                ImageDivs[i].remove();
                i = i - 1;
              }
            }
          }
          this.highlightParadotted(article);
          this.addIntegratedText(article);
          this.removeNormData(article);
        }
      }
    }

    else if (noFilter.length == this.pendingContentDataList.length) {
      let ImageDivs1 = article.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
      for (let i = 0; i < ImageDivs1.length; i++) {
        if (ImageDivs1 != undefined && ImageDivs1.length > 0) {
          if (ImageDivs1[i]) {
            ImageDivs1[i].remove();
          }
          i = i - 1
        }
      }
      this.highlightParadotted(article);
    }
    else {
      this.highlightParaSolid(article);

    }
  }
  highlightParadotted(article) {
    let paraParentElement = article.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
    paraParentElement.classList.add("pending-content-frame");
  }
  highlightParaSolid(article) {
    let paraParentElement = article.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
    paraParentElement.classList.add("pending-content-frame-solid");
  }

  addIntegratedText(article) {

    let ImageDivs = article.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
    let paraParentElement = article.parentElement.parentElement.parentElement.parentElement
    if (ImageDivs.length > 0) {
      for (let i = 0; i < ImageDivs.length; i++) {
        let divBlock = document.createElement("div");
        let img = document.createElement("img");
        img.src = "../../../../assets/icons/Pending.svg";
        img.alt = "Integrated Image";
        img.className = "pending-image";
        let textBlock = document.createElement("span");
        textBlock.innerText = "Integrated Pending Content";
        textBlock.className = "mr-1rem";
        textBlock.className = "mt-3px";

        // divBlock.appendChild(textBlock);
        //divBlock.appendChild(img);
        divBlock.className = "Integrated-Content";
        this.commonDataService.showRightPanel.pipe(takeUntil(this.destroy$)).subscribe(data => { if (data) { divBlock.style.width = "89.2%" } });
        paraParentElement.insertBefore(divBlock, paraParentElement.lastChild);
        this.addSpacebeforeSfragment(article)
      }
    }
    let dateSection = article.getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

    if (dateSection.length > 0) {
      for (let j = 0; j < dateSection.length; j++) {
        let divBlock1 = document.createElement("div");
        dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
        dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
        dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

        let guidanceLink = dateSection[j].nextElementSibling;
        if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
          guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
        }
      }
    }
  }
  removeNormData(article) {
    let normText = article.getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;
    if (normText != undefined && normText != null && normText.length > 0) {
      normText[0].remove();
    }
    let pendingTextColour = article.getElementsByClassName("div pending-text") as HTMLCollectionOf<HTMLElement>;
    if (pendingTextColour != undefined && pendingTextColour != null && pendingTextColour.length > 0) {
      pendingTextColour[0].classList.remove("pending-text");
    }
  }
  removePendingData(article) {
    let ImageDivs = article.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
    if (ImageDivs != undefined && ImageDivs != null && ImageDivs.length > 0) {
      ImageDivs[0].remove()
    }
  }
  //anchorWhiteSpaceRemove() {
  //  let items = document.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
  //  if (items != undefined && items != null) {
  //    for (let i = 0; i < items.length; i++) {
  //      let element = items[i];
  //      let text = element.innerHTML.trim();
  //      items[i].innerHTML = text;
  //      //if (element.getAttribute('class') == "xref") {
  //      //  let ahref = element.innerText;
  //      //  if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
  //      //  if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
  //      //  let otherSourceUrlParts = element.getAttribute('href').split("/");
  //      //  items[i].setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + ahref);
  //      //}
  //    }
  //  }
  //}
  firstAnchorRemove(article) {
    let items = article.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    if (items != undefined && items != null && items.length > 0) {
      items[0].remove();
    }
  }


  ngAfterViewInit(): void {
    //this.addPdfImage();
    if (!this.preloadContentPage.includes(this.router.url?.split("/")[1])) {
      this.addImage();
    }
    this.addPendingContent();
    if (this.ParentComponent != "showAllInOnePage") {
      this.XBRLReturnScroll();
    }
    this.commonDataService.showLoader.next(false);
    //this.anchorWhiteSpaceRemove();
    //this.mergeTableCells();
    //this.setRangeLinksStyling();
    //if (this.elementRef.nativeElement.querySelector('.term')) {
    //  this.elementRef.nativeElement.querySelector('.term').addEventListener('click', this.redirectInlineGlossary.bind(this));
    //}
  }

  XBRLReturnScroll() {
    let ReturnParaLink = localStorage.getItem("xbrlReturnPathLink");
    let ReturnParaText = localStorage.getItem("xbrlReturnPathText");
    if (ReturnParaText != null && ReturnParaText != undefined && (ReturnParaLink == null || ReturnParaLink == undefined)) {
      if (document.getElementById(ReturnParaText.trim()) != null) {
        // document.getElementById(ReturnParaText.trim()).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        let node = document.getElementById(ReturnParaText.trim());
        scrollIntoView(node, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          boundary: document.getElementsByTagName('app-main-content')[0]
        })
        localStorage.removeItem("xbrlReturnPathText");
      }
    }
  }

  setRangeLinksStyling() {
    let rangeLinks = document.getElementsByClassName("xref-range") as HTMLCollectionOf<HTMLElement>;
    if (rangeLinks != undefined && rangeLinks != null && rangeLinks.length > 0) {
      for (let i = 0; i < rangeLinks.length; i++) {
        rangeLinks[i].style.display = 'inline';
      }
    }
  }

  redirectInlineGlossary() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
  }

  openLinkById(event) {
    let path: any = event.composedPath() as Array<any>; 
    event.preventDefault();
    let notUsedLink = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref NotUsed");
    if (!notUsedLink) {
      let firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
      //if (this.UserInfo.user.roles == "Basic") {
      //  if (firstAnchor && !firstAnchor.hasAttribute('routerrlink')) {
      //    if (firstAnchor.innerText.toLocaleLowerCase().includes(("accounting standards update").toLocaleLowerCase())) {
      //      this.graphQLService.getGASBLink().subscribe(data => {
      //        let FASBPath: string = "<a href='" + data + "' target='blank' class='dialog highlight-blue border-bottom-help cursor-pointer singleLine'>" + data + "</a>";
      //        this.commonDataService.CrossRefReportNotGenerated.next(false);
      //        this.commonDataService.isConfirmationPopUpOpen.next(true);
      //        let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      //          disableClose: true,
      //          width: '600px',
      //          data: constObj.notAvailableForBAsic + FASBPath
      //        });
      //      }, err => {
      //        console.log(err);
      //        this.commonDataService.showLoader.next(false);
      //      });
      //    }
      //    else {
      //      this.commonDataService.paraNumClicked.next(this.paraNum);
      //      this.linkClicked(event);
      //    }
      //  }
      //  else {
      //    this.commonDataService.paraNumClicked.next(this.paraNum);
      //    this.linkClicked(event);
      //    if (firstAnchor && !firstAnchor.hasAttribute('routerrlink')) { this.eventemit.emit(); }
      //  }
      //}
      //else {
        this.commonDataService.showAllPageUrlClicked.next(this.pageurl);
        this.commonDataService.paraNumClicked.next(this.paraNum);
        this.linkClicked(event);
      if (firstAnchor && !firstAnchor.hasAttribute('routerrlink')) { this.eventemit.emit() }
      let linktopdf = path.find(p => p.tagName && p.tagName.toLowerCase() === 'span');
      if (linktopdf && linktopdf.hasAttribute('aria-sname') && linktopdf.hasAttribute('aria-snumber'))
      {
        let data = this.getsnum(linktopdf);
      
        let s1 = data['ariaSname'];
        let s2  = data['ariaSnumber'];

        this.loginService.getsname(s2, s1).subscribe((x:any) => {
          window.open(x.link);
        });
      
      }

      

      
    }
    else {
      let href = notUsedLink.getAttribute('href');
      this.router.navigateByUrl(href.split('/')[1] + "/" + href.split('/')[2] + "/noticeToConstituents");
    }
  }

  url: string = "";
  linkClicked(event) {
    let path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    let firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    let ditamap = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "ditamap");
    if (firstAnchor && !firstAnchor.hasAttribute('routerrlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href.split("/");
      let otherSourceUrlLastPart = href.includes('#') ? href.split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      let pageHeading = document.getElementById("pageHeading");
      let secPageHeading = document.getElementById("pageHeadingSec");
      if (((pageHeading != null || secPageHeading != null || window.location.href.includes("showallinonepage") || window.location.href.includes("showallinonepageplus")) && (pageHeading?.innerHTML?.toLocaleLowerCase().includes("glossary") || secPageHeading?.innerHTML?.toLocaleLowerCase().includes("glossary") || window.location.href.includes("showallinonepage")) && isNaN(Number(firstAnchor.innerText.split("-")[0])) && !firstAnchor.innerText.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase())
        && !firstAnchor.innerText.toLocaleLowerCase().includes(("Maintenance Update").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("html").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())
        && !firstAnchor.innerText.toLocaleLowerCase().includes(("example").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("paragraph").toLocaleLowerCase()))) {
        // this.router.navigateByUrl("MasterGlossary");
        // this.commonDataService.glossaryTerm.next(firstAnchor.innerText);
        this.commonDataService.glossaryTermId.next(otherSourceUrlLastPart);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next("inline-glossary");
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      }
      else if (firstAnchor.innerText.toLocaleLowerCase().includes("maintenance update") || firstAnchor.innerText.toLocaleLowerCase().includes("accounting standards update") || firstAnchor.innerText.toLocaleLowerCase().includes(("section")) || firstAnchor.innerText.toLocaleLowerCase().includes("subsection")) {
        let otherSourceUrlParts1 = event.target.getAttribute('href').split("/");
        //this.router.navigateByUrl(otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlParts[otherSourceUrlParts.length - 1]);
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        this.popRedirectionHelper(otherSourceUrlParts1[1] + "/" + otherSourceUrlParts1[2] + "/" + otherSourceUrlLastPart, 1);
      }
      else if (firstAnchor.innerText.toLocaleLowerCase().includes("notice to constituents")) {
        let otherSourceUrlParts2 = event.target.getAttribute('href').split("/");
        // this.router.navigateByUrl(otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/noticeToConstituents");
        this.popRedirectionHelper(otherSourceUrlParts2[1] + "/" + otherSourceUrlParts2[2] + "/noticeToConstituents", 1);
      }
      else {
        let firstAnchorInnerText = "";
        if (firstAnchor.innerText.includes("(")) {
          firstAnchorInnerText = firstAnchor.innerText.split("(")[0];
        }
        if (firstAnchor.innerText.includes("[")) {
          firstAnchorInnerText = firstAnchor.innerText.split("[")[0];
        }
        if (firstAnchor.innerText.includes("to")) {
          firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText.split(" to")[0] : firstAnchor.innerText.split(" to")[0]
        }
        if (firstAnchor.innerText.includes("through")) {
          firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText.split(" through")[0] : firstAnchor.innerText.split(" through")[0];
        }
        firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText : firstAnchor.innerText;
        if ((!this.router.url.includes("showallinonepage") && (!this.router.url.includes("showallinonepageplus") && (this.router.url.split("/")[2] != otherSourceUrlParts[2])) || ((this.router.url.includes("showallinonepage") || this.router.url.includes("showallinonepageplus")) && (this.url.split("/")[1] != otherSourceUrlParts[2])))) {
          if (firstAnchorInnerText.includes("-") && firstAnchorInnerText.split("-").length >= 2) {
            if ((this.pageNums != firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[2]) &&
              (this.pageNums != firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2])) {
            let navSplit = firstAnchorInnerText.split("-");
              let url = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
              let otherSourceUrl = "/" + url + "/" + firstAnchorInnerText;
              //this.router.navigate([otherSourceUrl]);
              this.popRedirectionHelper(otherSourceUrl, 2);
            }
            else {
              if (firstAnchorInnerText.includes("-")) {
                //let firstAnchornode = document.getElementById(firstAnchorInnerText);
                if (this.pageNums == firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]) {
                  if (firstAnchorInnerText.split("-").length == 4) {
                    firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2] + "-" + firstAnchorInnerText.split("-")[3]
                  } else {
                    firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]
                  }
                  //firstAnchornode = document.getElementById(firstAnchorInnerText);
                }
                //let historyData = {};
                let url: string = "";
                if (this.router.url.includes("-") && this.router.url.split("-").length >= 2) {

                  let navSplit = this.router.url.split("/")[this.router.url.split("/").length - 1].split("-");
                  let urlFetched = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
                  url = urlFetched + "/" + firstAnchorInnerText;
                }
                else {
                  url = this.router.url + "/" + firstAnchorInnerText;
                }
                //history.pushState(historyData, "scrollUrl", url);
                //this.RetainInPagePosition(firstAnchornode, url);
                this.router.navigateByUrl(url);
              }
              else {
                var otherSourceUrlPartsnode = document.getElementById(otherSourceUrlLastPart);
                scrollIntoView(otherSourceUrlPartsnode, {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
              }
            }
          }
          else {
            let otherSourceUrl = "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart;
            //this.router.navigate([otherSourceUrl]);
            this.popRedirectionHelper(otherSourceUrl, 2);
          }
        }
        else {
          if (firstAnchor.innerText.includes("-")) {
            if (this.pageNums == firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]) {
              if (firstAnchorInnerText.split("-").length == 4) {
                firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2] + "-" + firstAnchorInnerText.split("-")[3]
              } else {
                firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]
              }
            }
            let url: string = "";
            if (this.router.url.includes("-") && this.router.url.split("-").length >= 2) {

              let navSplit = this.router.url.split("/")[this.router.url.split("/").length - 1].split("-");
              let urlFetched = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
              url = urlFetched + "/" + firstAnchorInnerText;
            }
            else {
              url = this.router.url + "/" + firstAnchorInnerText;
            }
            //history.pushState(historyData, "scrollUrl", url);
            //this.RetainInPagePosition(firstAnchornode, url);
            this.router.navigateByUrl(url);
          }
          else {
            var otherSourceUrlPartsnode1 = document.getElementById(otherSourceUrlParts[otherSourceUrlParts.length - 1]);
            scrollIntoView(otherSourceUrlPartsnode1, {
              block: 'start',
              inline: 'start',
              boundary: document.getElementsByTagName('app-main-content')[0]
            })
          }
        }
      }
    }
    else if (ditamap != null) {
      let navPath = ditamap.innerText.split("-");
      if (navPath.length >= 3) {
        let navPathUrl: string = "";
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          if (navPath[0].includes("Section ")) {
            navPath[0] = navPath[0].replace("Section ", "");
          }
          navPathUrl = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          this.navPathTreeCall$ = this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { navPathUrl = data; });
        }
        if (this.router.url.split("/")[2] != navPathUrl.split("/")[1]) {
          // this.router.navigateByUrl(navPathUrl + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          this.popRedirectionHelper(navPathUrl + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2], 1);
        }
        else {
          var ditamapnode = document.getElementById(ditamap.innerText);
          scrollIntoView(ditamapnode, {
            scrollMode: 'always',
            block: 'start',
            inline: 'start',
            boundary: document.getElementsByTagName('app-main-content')[0]
          })
        }
      }
      else {
        this.eventemit.emit();
        //this.router.navigateByUrl("/" + ditamap.innerText + "/tableOfContent");
        this.popRedirectionHelper("/" + ditamap.innerText + "/tableOfContent", 1);
      }
    }
    else {
      this.openLinkByIdInternal(event);
    }
  }
  /* Start -- Print queue functionality request MS-415*/
  popRedirectionHelper(event, x) {    
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      localStorage.setItem("isConfirmPopup", 'true');
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          switch (x) {
            case 1: {
              this.router.navigateByUrl(event);
              break;
            }
            case 2: {
              this.router.navigate([event]);
              break;
            }
          }
        }
      });
      return;
    }
    else {
      switch (x) {
        case 1: {
          this.router.navigateByUrl(event);
          break;
        }
        case 2: {
          this.router.navigate([event]);
          break;
        }
      }
    }
  }
  /* End -- Print queue functionality request MS-415*/
  openLinkByIdInternal(event, isSitesBucket = false) {
    let id = event.target.getAttribute('id');
    let glossary_term_class = event?.target?.className;

    if (id !== null) {
      if (id.trim()[0] === '/') {
        if(id.includes("helppendingcontent")){
          this.commonDataService.showRightPanel.next(true);
          this.commonDataService.rightOverlayOption.next("helppendingcontent");
          this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        }
        else{
          this.router.navigateByUrl(id);
        }
      }
      else if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {

        let url = '/layoutComponents/getPdf?isSitesBucket=' + isSitesBucket + '&fileName=' + id;//show pdf
        window.open(url);

      }
      else if (id.includes('http')) {
        window.open(id);
      }
      else if (glossary_term_class == "term") {
        this.commonDataService.glossaryTermId.next("");
        if (id != "" && id != null) {
          this.commonDataService.glossaryTermId.next(id);
          this.commonDataService.showRightPanel.next(true);
          this.commonDataService.rightOverlayOption.next("inline-glossary");
          this.commonDataService.rightPanelWidth.next("rightOverLay_small");
          if (this.router.url == "/crossreference") {
            this.commonDataService.glossaryFromCrossReference.next(true);
            this.commonDataService.NavigatingFromComponent.next("ContentPage");
            this.commonDataService.childComponent.next(true);
          }
          else if (this.router.url == "/pendingcontentsystem" || this.router.url == "/pendingcontentintegeration") {
            this.commonDataService.NavigatingFromComponent.next("PendingContentviewer");
            this.commonDataService.childComponent.next(true);
          }
          else {
            this.commonDataService.glossaryFromCrossReference.next(false);
          }
        }
      }
    }
  }

  //RetainInPagePosition(firstAnchornode, url) {
  //  url = url.startsWith("/") ? url.substring(1) : url;
  //  let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
  //  let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
  //  let scrollDataArray = JSON.parse(sessionStorage.getItem('inPageScrollPositionRetentionData'));
  //  let lastUrl = sessionStorage.getItem('inPageScrollLastUrl') == null ? this.router.url : sessionStorage.getItem('inPageScrollLastUrl');
  //  lastUrl = lastUrl.startsWith("/") ? lastUrl.substring(1) : lastUrl;
  //  let currentPosition = sessionStorage.getItem('inPageScrollCurrentNum') == null ? -1 : parseInt(sessionStorage.getItem('inPageScrollCurrentNum'));
  //  if (scrollDataArray == null) { scrollDataArray = []; }
  //  if (currentPosition == null) { currentPosition = -1; }
  //  if (top != undefined && height != undefined) {
  //    if (scrollDataArray.length == currentPosition + 1) {
  //      if (scrollDataArray[currentPosition] != undefined && scrollDataArray[currentPosition]?.url == lastUrl) {
  //        scrollDataArray[currentPosition].scrollHeight = height;
  //        scrollDataArray[currentPosition].scrollTop = top;
  //      } else {
  //        scrollDataArray.push({ scrollHeight: height, scrollTop: top, url: lastUrl });
  //        currentPosition = currentPosition + 1;
  //      }
  //      sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //    }
  //    else {
  //      scrollDataArray[currentPosition].scrollHeight = height;
  //      scrollDataArray[currentPosition].scrollTop = top;
  //      scrollDataArray[currentPosition].url = lastUrl;
  //      if (scrollDataArray.length > currentPosition + 1) {
  //        if (scrollDataArray[currentPosition + 1].url != url) {
  //          scrollDataArray[currentPosition + 1].url = url;
  //        }
  //      }
  //      sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //      currentPosition = currentPosition + 1;
  //    }
  //    sessionStorage.setItem("inPageScrollLastUrl", url);
  //    sessionStorage.setItem('inPageScrollCurrentNum', currentPosition.toString());
  //    scrollIntoViewIfNeeded(firstAnchornode, {
  //      block: 'start',
  //      inline: 'start',
  //      boundary: document.getElementsByTagName('app-main-content')[0]
  //    });
  //  }
  //}

  redirectToGlossaryTermUsage(event) {
    /*if (this.UserInfo.user.roles != "Basic") {*/
      let id = event.target.id;
      this.graphQLService.getInlineGlossaryContent(id).subscribe(glossaryData => {
        if (glossaryData) {
          this.mapGlossaryContent(glossaryData?.hits?.hitsList);
          this.commonDataService.glossaryTermData.next(this.glossaryData);
          this.commonDataService.showRightPanel.next(true);
          this.commonDataService.rightOverlayOption.next("glossary-term-usage");
          this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        }
      })
    //}
    //else {
    //  this.commonDataService.CrossRefReportNotGenerated.next(false);
    //  this.commonDataService.isConfirmationPopUpOpen.next(true);
    //  let dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //    disableClose: true,
    //    width: '600px',
    //    data: constObj.glossaryTermClickForBasic
    //  });
    //}

  }
  contacts: any = [];
  distinctTopics: any = [];
  glossarytopic: any;
  glossaryTitle: any;
  glossaryData: any = {};
  mapGlossaryContent(data) {
    if (data) {
      data.forEach(res => {
        this.glossarytopic = [];
        this.distinctTopics = [];
        this.contacts = [];
        let source = res.source;
        this.glossaryTitle = source.title;
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.glossarytopic.push(usage)
          });
        }
        let count = 0;
        if (this.glossarytopic.length > 0) {
          this.glossarytopic.forEach(topicRes => {
            if (count == 0) {
              let obj = {
                topic: topicRes.topic,
                topicData: [topicRes]
              }
              this.distinctTopics.push(obj);
              count++;
            }
            else {
              let topics = this.distinctTopics.filter(x => x.topic == topicRes.topic);
              if (topics.length > 0) {
                this.distinctTopics.filter(x => x.topic == topicRes.topic)[0].topicData.push(topicRes);
              }
              else {
                let obj = {
                  topic: topicRes.topic,
                  topicData: [topicRes]
                }
                this.distinctTopics.push(obj);
              }
              count++;
            }
          })
        }
        this.distinctTopics = this.distinctTopics.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.glossarytopic = this.glossarytopic.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.glossaryData = { name: this.glossaryTitle, body: "", topic: this.glossarytopic, seetopic: this.distinctTopics, type: source.glossaryType };
        this.contacts.push(this.glossaryData);
      })
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 8; i >= 0; i--) {
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }
}
